import { render, staticRenderFns } from "./SignUpStepHeader.vue?vue&type=template&id=22d6ed66&scoped=true"
import script from "./SignUpStepHeader.vue?vue&type=script&lang=js"
export * from "./SignUpStepHeader.vue?vue&type=script&lang=js"
import style0 from "./SignUpStepHeader.vue?vue&type=style&index=0&id=22d6ed66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d6ed66",
  null
  
)

export default component.exports